let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kP2uL")).then(() => parcelRequire('7toVV'));